import { TApiTaskDetails } from "@timenotes/shared/src/services/api-client/types"
import { Form, FormikProvider } from "formik"
import { TaskDescriptionField } from "./task-description-field"
import { TaskComment } from "./sidebar/task-comment"
import { NewTaskComment } from "./new-task-comment"
import { TaskAssigneesSelectPopover } from "components/timenotes/tasks/task-details-modal/sidebar/task-assignees-select-popover"
import { useTaskFormik } from "@timenotes/shared/src/services/tasks/hooks/use-task-formik"
import { TaskProjectSelectPopover } from "./sidebar/task-project-select-popover"
import { TaskProjectSectionSelectPopover } from "./sidebar/task-project-section-select-popover"
import { TaskTagsPopover } from "./sidebar/task-tags-popover"
import { TaskBillableSwitch } from "./sidebar/task-billable-switch"
import { TaskBillableRatePopover } from "./sidebar/task-billable-rate-popover"
import { TaskEstimatedTimePopover } from "./sidebar/task-estimated-time-popover"
import { TaskSummary } from "./sidebar/task-summary"
import styled from "styled-components"
import { TaskDetailsTimesheetModal } from "./task-details-timesheet-modal"
import { useTaskDetailsModal } from "./task-details-modal"
import { message } from "antd"
import { usePagePermissions } from "hooks/permissions.hooks"
import { getApiErrorMessage } from "@timenotes/shared/src/services/api-client"

interface TaskDetailsModalBodyProps {
  task: TApiTaskDetails
}

export const TaskDetailsModalBody = (props: TaskDetailsModalBodyProps) => {
  const {
    task
  } = props

  const projectId = task.project.id

  const { permissions } = usePagePermissions()
  const canSeeBillable = !!permissions?.filterBillableTimelogs 

  const {
    closeTaskModal
  } = useTaskDetailsModal()

  const formik = useTaskFormik({
    projectId: projectId,
    initialValues: task,
    onSuccess: (taskValues) => {
      // Is success and project id changed
      if (taskValues.project?.id !== projectId) {
        message.warn("Task was moved to another project and is no longer visible!")
        closeTaskModal()
      }
    },

    // Display first error message by default
    onError: (taskValues, errors) => {
      if (errors == undefined || Object.keys(errors).length === 0) {
        message.error("Something went wrong")
        return
      }

      const firstErrorKey = Object.keys(errors).find(key => key !== 'base') || Object.keys(errors)[0]
      const errorMessage = errors[firstErrorKey]?.[0] || errors.base?.[0] || "Something went wrong"
      message.error(errorMessage)
      formik.resetForm()
    }
  })

  return (
    <FormikProvider value={formik}>
      <Form>
        <div
          style={{
            display: 'flex',
          }}
        >
          <div
            style={{
              flexGrow: 1,
              padding: '20px',
              backgroundColor: 'rgb(250, 250,250)'
            }}
          >

            <TaskDescriptionField />

            <br />

            <h3>
              Comments ({task.comments.length})
            </h3>

            <NewTaskComment 
              taskId={task.id}
              projectId={projectId}
            />

            { task.comments.map((comment) => (
              <TaskComment 
                key={comment.id}
                projectId={projectId}
                taskId={task.id}
                comment={comment} 
              />
            ))}

          </div>


          <div
            style={{
              width: '300px',
              flexShrink: 0, // disable shrinking
              borderLeft: '1px solid #eee',
              padding: '10px',
            }}
          >

            <TaskSummary />
            <Space />

            <TaskProjectSelectPopover />
            <Space />

            <TaskProjectSectionSelectPopover />
            <Space />

            <TaskTagsPopover />
            <Space />

            { task.project.billableEnabled && (
              <>
                <TaskBillableSwitch />
                <Space />

                { canSeeBillable && (
                  <>
                    <TaskBillableRatePopover />
                    <Space />
                  </>
                )}
              </>
            )}

            <TaskEstimatedTimePopover />
            <Space />

            <TaskAssigneesSelectPopover />

          </div>
        </div>
      </Form>

      <TaskDetailsTimesheetModal />

    </FormikProvider>
  )
}

const Space = styled.div`
  height: 10px;
  border-bottom: 1px solid #efefef;
  margin-bottom: 5px;
`